export const BEDROCK_IMAGE_TYPES_TYPE = {
  IMAGE: 'IMAGE',
  BACKGROUND: 'BACKGROUND',
  CLIPART: 'CLIPART'
};

export const BEDROCK_IMAGE_SIZES_TYPE = {
  W1024xH1024: 'W1024xH1024',
  W768xH768: 'W768xH768',
  W512xH512: 'W512xH512',
  W768xH1152: 'W768xH1152',
  W384xH576: 'W384xH576',
  W1152xH768: 'W1152xH768',
  W576xH384: 'W576xH384',
  W768xH1280: 'W768xH1280',
  W384xH640: 'W384xH640',
  W1280xH768: 'W1280xH768',
  W640xH384: 'W640xH384',
  W896xH1152: 'W896xH1152',
  W448xH576: 'W448xH576',
  W1152xH896: 'W1152xH896',
  W576xH448: 'W576xH448',
  W768xH1408: 'W768xH1408',
  W384xH704: 'W384xH704',
  W1408xH768: 'W1408xH768',
  W704xH384: 'W704xH384',
  W640xH1408: 'W640xH1408',
  W320xH704: 'W320xH704',
  W1408xH640: 'W1408xH640',
  W704xH320: 'W704xH320',
  W1152xH640: 'W1152xH640',
  W1173xH640: 'W1173xH640',
  SINGLE_PAGE_BACKGROUND_SIZE: 'single_page_background_size',
  SPREAD_BACKGROUND_SIZE: 'spread_background_size'
};
